<template>
    <el-dialog
            :title="$t('common.confirmDeleteDialogTitle')"
            :visible.sync="dialogVisible"
            width="30%">
       {{$t('common.confirmDeleteMessage')}}
        <span slot="footer" class="dialog-footer">
            <el-button @click="hide">{{$t('common.cancelBtn')}}</el-button>
            <el-button type="danger" @click="onDelete">{{$t('common.deleteBtn')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "DeleteDialog",
        data() {
            return {
                dialogVisible: false,
            }
        },
        methods: {
            show() {
                this.dialogVisible = true;
            },
            hide() {
                this.dialogVisible = false;
            },
            onDelete() {
                this.hide();
                this.$emit('delete');
            }
        }
    }
</script>

<style scoped>

</style>
